import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import { getAlert } from "../Services/appAlerts";
import { useUploadAppDocumentsMutation } from "../app/store/candidateApiSlice";
import { getCurrentUser } from "../app/store/auth";
import { uploadFileToBlob } from "../Services/blobUploadService";

const UPLOAD_DOC_POPUP_STYLES = {
  modalContent: {
    borderRadius: "0px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
      borderBottom: "1px solid #e2e8f0",
    color: "#0f172a",
    fontSize: "21px",
    boxShadow: "none",
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: 0,
    fontWeight: "normal"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  helperCard: {
    borderRadius: "0px",
    padding: "16px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  sectionCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
    marginBottom: "16px",
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "6px",
  },
  sectionSubtitle: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#64748b",
    marginBottom: "14px",
  },
  dropZone: {
    border: "2px dashed rgba(148, 163, 184, 0.45)",
    borderRadius: "0px",
    padding: "30px 22px",
    textAlign: "center",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  dropZoneActive: {
    borderColor: "rgba(59, 130, 246, 0.7)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    boxShadow: "inset 0 0 0 1px rgba(147, 197, 253, 0.55)",
  },
  dropIcon: {
    width: "60px",
    height: "60px",
    margin: "0 auto 14px auto",
    borderRadius: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
      borderBottom: "1px solid #e2e8f0",
    color: "#0f172a",
    fontSize: "26px",
  },
  dropTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "6px",
  },
  dropText: {
    fontSize: "13px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  fileList: {
    display: "grid",
    gap: "12px",
  },
  fileRow: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "12px 14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
  },
  fileMeta: {
    minWidth: 0,
    flex: 1,
  },
  fileName: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#0f172a",
    wordBreak: "break-word",
  },
  fileSubtext: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  removeButton: {
    width: "34px",
    height: "34px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  textArea: {
    minHeight: "110px",
    borderRadius: "0px",
    border: "1px solid rgba(203, 213, 225, 1)",
    padding: "12px 14px",
    fontSize: "13px",
    color: "#0f172a",
    resize: "vertical",
    width: "100%",
    outline: "none",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  sendButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  sendButtonDisabled: {
    opacity: 0.55,
    boxShadow: "none",
  },
};

const formatFileSize = (sizeInBytes) => {
  if (!sizeInBytes && sizeInBytes !== 0) return "";
  if (sizeInBytes < 1024) return `${sizeInBytes} B`;
  if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  return `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`;
};

const UploadDocPopup = (props) => {
  const {
    uploadDocShowHide,
    handleUploadDocModalShowHide,
    selectedDocType,
    runningApplication,
    messageAlert,
    contactDoc = "",
  } = props;

  const [documents, setDocuments] = useState([]);
  const [notes, setNotes] = useState("");
  const [btnProcess, setBtnProcess] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const currentUser = useMemo(() => getCurrentUser(), []);
  const fileInputRef = useRef(null);
  const processedUploadResultRef = useRef("");

  const usrId = useMemo(() => {
    if (!currentUser) return null;
    return currentUser.linkUser || currentUser.id;
  }, [currentUser]);

  const [uploadAppDocuments, { data: uploadResult, reset: resetUpload }] = useUploadAppDocumentsMutation();

  useEffect(() => {
    if (!uploadDocShowHide) {
      setDocuments([]);
      setNotes("");
      setBtnProcess(false);
      setIsDragging(false);
      processedUploadResultRef.current = "";
    }
  }, [uploadDocShowHide]);

  const addFiles = useCallback((fileList) => {
    const incomingDocs = Array.from(fileList || []).map((file) => ({
      name: file.name,
      type: file.type,
      size: file.size,
      file,
    }));

    if (incomingDocs.length === 0) return;

    setDocuments((prev) => [...prev, ...incomingDocs]);
  }, []);

  const doSubmit = useCallback(async () => {
    if (!documents.length) {
      getAlert("", "Document not found", "error");
      return;
    }

    if (!runningApplication || !runningApplication[0]) {
      getAlert("", "Workflow details not found", "error");
      return;
    }

    setBtnProcess(true);
    const data = new FormData();
    data.append("message", notes);
    data.append("workflowTask", JSON.stringify(runningApplication[0]));
    data.append("userId", usrId);
    data.append("docType", !selectedDocType ? "" : selectedDocType);
    data.append(
      "files",
      JSON.stringify(
        documents.map((file) => ({
          name: file.name,
          type: file.type,
          size: file.size,
        }))
      )
    );

    try {
      const response = await uploadAppDocuments(data).unwrap();
      const sasUrls = response?.sasUrls || [];

      if (sasUrls.length > 0) {
        await Promise.all(
          documents.map((file, key) => {
            if (sasUrls[key]?.uploadUrl) {
              return uploadFileToBlob(file.file, sasUrls[key].uploadUrl, () => { });
            }
            return Promise.resolve();
          })
        );
      }

      setBtnProcess(false);
      if (messageAlert && messageAlert !== "") {
        getAlert("", messageAlert, "success");
      } else {
        getAlert("", `${contactDoc === "" ? "Sent Successfully" : contactDoc}`, "success");
      }
      resetUpload();
      handleUploadDocModalShowHide("save", "");
    } catch (error) {
      console.error("Upload failed:", error);
      setBtnProcess(false);
      getAlert("", "File upload failed", "error");
    }
  }, [documents, runningApplication, usrId, notes, selectedDocType, uploadAppDocuments, messageAlert, contactDoc, handleUploadDocModalShowHide, resetUpload]);

  const onFileChange = useCallback((event) => {
    addFiles(event.target.files);
    event.target.value = "";
  }, [addFiles]);

  const handleFileRemove = useCallback((item) => {
    setDocuments((prev) => prev.filter((doc) => doc !== item));
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback(() => {
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
    addFiles(e.dataTransfer.files);
  }, [addFiles]);

  const totalFiles = documents.length;
  const totalSize = useMemo(() => documents.reduce((sum, item) => sum + (item.size || 0), 0), [documents]);

  return (
    <Modal
      show={uploadDocShowHide}
      size="xl"
      centered
      onHide={() => handleUploadDocModalShowHide("", "")}
      dialogClassName="upload-doc-popup-modal-dialog"
      contentClassName="upload-doc-popup-modal-content"
    >
      <style>
        {`
          .upload-doc-popup-modal-dialog {
            max-width: ${UPLOAD_DOC_POPUP_STYLES.modalDialog.maxWidth};
          }
          .upload-doc-popup-modal-content {
            border-radius: ${UPLOAD_DOC_POPUP_STYLES.modalContent.borderRadius};
            overflow: ${UPLOAD_DOC_POPUP_STYLES.modalContent.overflow};
            border: ${UPLOAD_DOC_POPUP_STYLES.modalContent.border};
            box-shadow: ${UPLOAD_DOC_POPUP_STYLES.modalContent.boxShadow};
          }
        `}
      </style>

      <Modal.Header style={UPLOAD_DOC_POPUP_STYLES.modalHeader}>
        <div style={UPLOAD_DOC_POPUP_STYLES.headerContent}>
          <Modal.Title as="div" style={UPLOAD_DOC_POPUP_STYLES.titleWrap}>
            <div style={UPLOAD_DOC_POPUP_STYLES.headerIcon}>
              <i className="fa fa-cloud-upload" aria-hidden="true"></i>
            </div>
            <div>
              <div style={UPLOAD_DOC_POPUP_STYLES.title}>Upload Documents</div>
              <div style={UPLOAD_DOC_POPUP_STYLES.subtitle}>
                Add one or more files, include an optional message, and send everything in a single upload.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={UPLOAD_DOC_POPUP_STYLES.closeButton}
            onClick={() => handleUploadDocModalShowHide("", "")}
            aria-label="Close upload document popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={UPLOAD_DOC_POPUP_STYLES.modalBody}>
        <div style={UPLOAD_DOC_POPUP_STYLES.helperCard}>
          <div style={UPLOAD_DOC_POPUP_STYLES.helperTitle}>Upload guidance</div>
          <p style={UPLOAD_DOC_POPUP_STYLES.helperText}>
            Drag files into the drop area or browse from your device. You can upload multiple documents
            at once and include a note to help reviewers understand what was sent.
          </p>
        </div>

        <div style={UPLOAD_DOC_POPUP_STYLES.sectionCard}>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionTitle}>Files</div>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionSubtitle}>
            {totalFiles > 0
              ? `${totalFiles} file${totalFiles > 1 ? "s" : ""} selected, ${formatFileSize(totalSize)} total`
              : "No files selected yet."}
          </div>

          <div
            style={{
              ...UPLOAD_DOC_POPUP_STYLES.dropZone,
              ...(isDragging ? UPLOAD_DOC_POPUP_STYLES.dropZoneActive : {}),
            }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}
          >
            <div style={UPLOAD_DOC_POPUP_STYLES.dropIcon}>
              <i className="fa fa-paperclip" aria-hidden="true"></i>
            </div>
            <div style={UPLOAD_DOC_POPUP_STYLES.dropTitle}>
              {isDragging ? "Drop files here" : "Drag and drop files here"}
            </div>
            <p style={UPLOAD_DOC_POPUP_STYLES.dropText}>
              {isDragging
                ? "Release to add the selected files."
                : "Or click anywhere in this area to browse and select documents."}
            </p>
          </div>
        </div>

        {documents.length > 0 && (
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionCard}>
            <div style={UPLOAD_DOC_POPUP_STYLES.sectionTitle}>Selected documents</div>
            <div style={UPLOAD_DOC_POPUP_STYLES.sectionSubtitle}>
              Review the files below before sending them.
            </div>

            <div style={UPLOAD_DOC_POPUP_STYLES.fileList}>
              {documents.map((file, index) => (
                <div key={`${file.name}-${index}`} style={UPLOAD_DOC_POPUP_STYLES.fileRow}>
                  <div style={UPLOAD_DOC_POPUP_STYLES.fileMeta}>
                    <div style={UPLOAD_DOC_POPUP_STYLES.fileName}>{file.name}</div>
                    <div style={UPLOAD_DOC_POPUP_STYLES.fileSubtext}>
                      {formatFileSize(file.size)}
                      {file.type ? ` | ${file.type}` : ""}
                    </div>
                  </div>
                  <button
                    type="button"
                    style={UPLOAD_DOC_POPUP_STYLES.removeButton}
                    onClick={() => handleFileRemove(file)}
                    aria-label={`Remove ${file.name}`}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={UPLOAD_DOC_POPUP_STYLES.sectionCard}>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionTitle}>Message</div>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionSubtitle}>
            Add any context or notes for the uploaded documents.
          </div>
          <textarea
            name="message"
            id="message"
            className="form-control"
            value={notes}
            onChange={({ currentTarget }) => setNotes(currentTarget.value)}
            style={UPLOAD_DOC_POPUP_STYLES.textArea}
            placeholder="Add a short note for the reviewer or support team."
          ></textarea>
        </div>



        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileChange}
          aria-label="Upload files"
          multiple
          accept=".pdf,.docx,.doc,.jpg,.jpeg,.png,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/jpeg,image/png"
          style={{ display: "none" }}
        />
      </Modal.Body>
      <Modal.Footer style={UPLOAD_DOC_POPUP_STYLES.modalFooter}>
        <div style={UPLOAD_DOC_POPUP_STYLES.footerActions}>
          <button
            type="button"
            style={UPLOAD_DOC_POPUP_STYLES.cancelButton}
            onClick={() => handleUploadDocModalShowHide("", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Cancel
          </button>
          <Button
            type="button"
            style={{
              ...UPLOAD_DOC_POPUP_STYLES.sendButton,
              ...(btnProcess || documents.length === 0
                ? UPLOAD_DOC_POPUP_STYLES.sendButtonDisabled
                : {}),
            }}
            onClick={doSubmit}
            disabled={btnProcess || documents.length === 0}
          >
            <i
              className={`fa ${btnProcess ? "fa-circle-o-notch fa-spin" : "fa-paper-plane-o"}`}
              aria-hidden="true"
            ></i>
            {btnProcess ? "Sending..." : "Send"}
          </Button>
        </div>
      </Modal.Footer>

    </Modal>
  );
};

export default UploadDocPopup;
